export const COGNITO_AUTHORITY = process.env.REACT_APP_COGNITO_AUTHORITY!;
export const COGNITO_CLIENT_ID = process.env.REACT_APP_COGNITO_CLIENT_ID!;
export const COGNITO_REDIRECT_URI = process.env.REACT_APP_COGNITO_REDIRECT_URI!;
export const COGNITO_DOMAIN = process.env.REACT_APP_COGNITO_DOMAIN!;